var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAlertaDeDesconexionDeTomaDeFuerza(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 255.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#ba0202;}.cls-3{fill:#a30000;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-alerta-de-desconexion-de-toma-de-fuerza") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_38_copia_13",
    "data-name": "38 copia 13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.22,183.86a31.93,31.93,0,1,0,63.85,0c0-.55,0-1.09,0-1.64a31.93,31.93,0,0,0-63.77,0C108.23,182.77,108.22,183.31,108.22,183.86Zm11.47,0c0-.55,0-1.09.07-1.64a20.45,20.45,0,0,1,40.77,0c0,.55.07,1.09.07,1.64a20.46,20.46,0,1,1-40.91,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.64,166.92a27.76,27.76,0,0,1,49,0,27.44,27.44,0,0,1,3.24,11.64c0,.47,0,.95,0,1.42a27,27,0,0,1-.28,3.84h-3.21a24.27,24.27,0,0,0,.3-3.84c0-.6,0-1.25-.08-2a24.59,24.59,0,0,0-49,0c0,.71-.08,1.36-.08,2a24.27,24.27,0,0,0,.3,3.84h-3.22a28.57,28.57,0,0,1-.27-3.84c0-.47,0-.95,0-1.42h0A27.44,27.44,0,0,1,115.64,166.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,148.06A36.17,36.17,0,0,0,102,163a35.81,35.81,0,0,0-4.21,15.12c0,.62,0,1.24,0,1.85a37.39,37.39,0,0,0,.2,3.84H64.65l11-35.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.58,180c0-.61,0-1.23-.05-1.85a35.65,35.65,0,0,0-4.2-15.12,36.14,36.14,0,0,0-15.05-14.95h67.4v35.76H182.37A34.75,34.75,0,0,0,182.58,180Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.5 138.7 122.09 138.7 229.16 81.22 243.5 138.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "229.16 60.54 229.16 81.22 36.22 184.88 27.59 168.84 229.16 60.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.74 107.21 196.79 98.6 182 85.86 165.94 94.48 180.74 107.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.11 89.83 229.16 81.22 214.37 68.48 198.32 77.1 213.11 89.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.81 124.89 163.86 116.28 149.07 103.54 133.02 112.16 147.81 124.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.24 142.38 131.29 133.76 116.5 121.03 100.45 129.64 115.24 142.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.32 160.05 98.37 151.44 83.58 138.7 67.53 147.32 82.32 160.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.01 176.86 67.06 168.24 52.27 155.51 36.22 164.13 51.01 176.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.56,19.87a107.69,107.69,0,0,1,76.15,183.84A107.69,107.69,0,0,1,51.41,51.41a107,107,0,0,1,76.15-31.54m0-19.87A127.56,127.56,0,1,0,255.12,127.56,127.56,127.56,0,0,0,127.56,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.82,
    y1: 47.44,
    x2: 208.06,
    y2: 208.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111.86,
    y: 13.95,
    width: 31.16,
    height: 227.56,
    transform: "translate(-52.99 127.89) rotate(-45.12)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlertaDeDesconexionDeTomaDeFuerza);
export default __webpack_public_path__ + "static/media/ic-alerta-de-desconexion-de-toma-de-fuerza.7936f52d06be5d9f1ccfc731a3130376.svg";
export { ForwardRef as ReactComponent };